import React, {Component} from "react";
import PropTypes from "prop-types";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import initialState from "../../../reducers/communications/initialState";
import {Accordion, EmptyState} from "Ncontracts.Common.UI";
import {imageCdnUrls} from "../../common/ImageCdnUrls";

class NewCommunicationPreview extends Component {

    static propTypes = {
        includesPoll: PropTypes.bool,
        message: PropTypes.string,
        pollOptions: PropTypes.arrayOf(PropTypes.string),
        pollQuestion: PropTypes.string,
        recipients: PropTypes.array,
        showVoicePreview: PropTypes.bool,
        title: PropTypes.string,
    };

    static defaultProps = {
        ...initialState
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            previewType: 'email',
            showAccordion: false
        };
    }

    changePreviewType = newType => {
        this.setState({...this.state, previewType: newType});
    };

    renderIndicatorTypeTab = (type, label) => {
        const classNames = `column ${this.state.previewType === type ? 'selected-communication-type' : ''}`;
        return <div onClick={() => this.changePreviewType(type)} className={classNames}>{label}</div>;
    };

    renderPreviewBody = () => {
        switch (this.state.previewType) {
            case "email":
                return this.renderEmailBody();
            case "text":
                return this.renderTextBody();
            case "voice":
                return this.renderVoiceBody();
            default:
                return undefined;
        }
    };

    renderEmailBody = () => {
        const {title, message, includesPoll} = this.props;
        const messageClass = `preview-message email ${includesPoll ? 'with-poll' : ''}`;

        return (
            <>
                <div className="preview-title email">{title}</div>
                <div className={messageClass}>{message}</div>
                {includesPoll ? this.renderPollPreview() : undefined}
            </>
        );
    };

    renderPollPreview = () => {
        const {pollQuestion, pollOptions} = this.props;

        const pollOptionsList = pollOptions.map((option, index) => {
            return <div className="poll-option" key={index}>
                <div className="option-radio"><img src={imageCdnUrls.radio_unselected} width="12" height="12"/></div>
                <div className="option-text">{option}</div>
            </div>;
        });

        return (
            <div className="poll-preview">
                <div className="poll-question">{pollQuestion}</div>
                <div className="poll-options">{pollOptionsList}</div>
                <div className="poll-submit-pseudo-button">[Submit Button]</div>
            </div>
        );
    };

    renderTextBody = () => {
        const {title, message, includesPoll} = this.props;
        const pollLink = !includesPoll ? undefined : <div><a className="preview-poll-link semibold">https://link.ncontracts.com/ABC123</a></div>;
        return (
            <>
                <div className="preview-title sms">{includesPoll ? '' : title}</div>
                <div className="preview-message sms">
                    {pollLink}
                    {includesPoll ? title : message}
                    <span className="semibold">{"  Powered by Ncontracts."}</span>
                </div>
            </>
        );
    };

    renderVoiceBody = () => {
        const {title, message, showVoicePreview} = this.props;
        return !showVoicePreview ? this.renderVoiceEmptyState() : (
            <div className="preview-message voice">
                &quot;<span className="semibold">{`${title} `}</span>
                {message}
                <span className="semibold no-italics">{"  Powered by Ncontracts."}</span>&quot;
            </div>
        );
    };

    renderVoiceEmptyState = () => {
        return (
            <div className="preview-message voice">
                <EmptyState classes="no-communications-empty-state"
                            imageAlt="No voice call"
                            imageSrc={imageCdnUrls.comm_voice}
                            message="No voice call"/>
            </div>);
    };

    toggleAccordion = () => this.setState({...this.state, showAccordion: !this.state.showAccordion});

    render() {
        const {recipients} = this.props;
        const {previewType} = this.state;

        const previewLabel = previewType === 'email' ? 'Webpage layout' : '';

        const messageRecipients = recipients != null && recipients.length > 0
            ? <>{recipients.map(r => (<div key={r.id}>{r.displayName}</div>))}</>
            : <div>No recipients selected</div>;

        return (
            <div className="preview-container">
                <div className="communication-type-indicator columns is-mobile">
                    {this.renderIndicatorTypeTab('email', 'Email')}
                    {this.renderIndicatorTypeTab('text', 'Text')}
                    {this.renderIndicatorTypeTab('voice', 'Voice Call')}
                </div>
                <div className="preview-type-label">{previewLabel}</div>
                <div className="message-content">
                    {this.renderPreviewBody()}
                </div>
                <div className="recipients-accordion">
                    <Accordion headerLeft={"Recipients"}
                               toggleAccordion={this.toggleAccordion}
                               showAccordion={this.state.showAccordion}
                               itemCount={(recipients || []).length}
                               content={messageRecipients}/>
                </div>
            </div>);
    }
}

const mapStateToProps = state => ({
    includesPoll: state.newCommunication.includesPoll,
    message: state.newCommunication.message,
    pollOptions: state.newCommunication.pollOptions,
    pollQuestion: state.newCommunication.pollQuestion,
    recipients: state.newCommunication.selectedRecipients,
    showVoicePreview: state.newCommunication.sendVoiceCalls,
    title: state.newCommunication.title
});

export default withRouter(connect(mapStateToProps, null)(NewCommunicationPreview));
